/// <reference path="../@declaration/css-highlight-api.d.ts" />

const highlight = (value: string) => {
  CSS.highlights.delete('search');

  if (!value) {
    return;
  }

  const tableElement = document.querySelector<HTMLTableSectionElement>('#patient-table-list tbody') as HTMLTableSectionElement;

  const ranges = [];

  const walker = document.createTreeWalker(tableElement, NodeFilter.SHOW_TEXT);

  while (walker.nextNode()) {
    const node = walker.currentNode;

    const text = node.textContent;
    const search = value.toLowerCase();

    let index = 0;

    while ((index = (text || '').toLowerCase().indexOf(search, index)) !== -1) {
      const range = new Range();

      range.setStart(node, index);
      range.setEnd(node, index + value.length);

      ranges.push(range);

      index += value.length;
    }
  }

  CSS.highlights.set('table-search', new Highlight(...ranges));
};

export default highlight;
